import { createSelector } from 'selectors'
import { fileDownloader } from './constant'

const getButtons = () =>
	createSelector<NodeListOf<HTMLSelectElement>>({ selector: fileDownloader.selector.button }, true)

export const getFileDownloaderComponents = () => ({
	buttons: getButtons(),
})
